import { inView, animate, scroll, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockCaseStudyHero = document.querySelector('.block-case-study-hero');

    // Check if the homepage hero block exists
    if (!blockCaseStudyHero) {
        return;
    }

    const blockCaseStudyHeroContent = blockCaseStudyHero.querySelector('.block-case-study-hero__content');
    const blockCaseStudyHeroContentHeadingWords = blockCaseStudyHero.querySelectorAll('.block-case-study-hero__content__heading span');
    const blockCaseStudyHeroContentHeadingCategories = blockCaseStudyHeroContent.querySelectorAll('.block-case-study-hero__content__categories button');
    const blockCaseStudyHeroContentMedia = blockCaseStudyHeroContent.querySelector('.block-case-study-hero__content__media');

    // Animate each word to fade in one after another with a stagger.
    animate(blockCaseStudyHeroContentHeadingWords, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: stagger(0.15, { startDelay: 0.3 }) // Delay before animation starts and stagger words.
        }
    );
    animate(blockCaseStudyHeroContentHeadingCategories, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            // transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: stagger(0.15, { startDelay: 1 }) // Delay before animation starts and stagger words.
        }
    );
    animate(blockCaseStudyHeroContentMedia, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            transform: ['translateX(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: stagger(0.15, { startDelay: 1 }) // Delay before animation starts and stagger words.
        }
    );

    scroll(
        animate(blockCaseStudyHero.querySelector('.block-case-study-hero__content__heading'), 
            { y: [0, 2000] },  // Move the heading from 0 to -4000px along the Y-axis.
            { ease: "ease-in-out" } // Easing.
        ),
        {
            offset: ["start -200px", "end end"],
        }
    );

    scroll(
        animate(blockCaseStudyHero.querySelector('.block-case-study-hero__content__categories'), 
            { y: [0, 2000] },  // Move the heading from 0 to -4000px along the Y-axis.
            { ease: "ease-in-out" } // Easing.
        ),
        {
            offset: ["start -200px", "end end"],
        }
    );

    scroll(
        animate(blockCaseStudyHero.querySelector('.block-case-study-hero__content__media'), 
            { y: [0, 2000] },  // Move the heading from 0 to -4000px along the Y-axis.
            { ease: "ease-in-out" } // Easing.
        ),
        {
            offset: ["start -200px", "end end"],
        }
    );
});